import type { AllRouteEndpoints } from "../routeTypes";
export const emailIpWarmingAppGroupIdScheduleSettingsCacheKeys: AllRouteEndpoints[] = [];
